import React from 'react';
import {observer} from "mobx-react";
import {MenuItemComponentProps} from "../../services/menu-items-common/menu-item-component-props.interface";
import {BottomNavigationBarMenuItemBox} from "./boxes/menu-item/bottom-navigation-bar-menu-item.box";
import {BottomNavigationBarMenuItemTextBox} from "./boxes/menu-item-text/bottom-navigation-bar-menu-item-text.box";
import {BottomNavigationBarMenuItemIconComponent} from "./bottom-navigation-bar-menu-item-icon.component";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";
import classNames from 'classnames';
import {TOOLTIP_TARGET_BOTTOM_NAV_BAR_INDICATOR} from '../../services/tooltip/on-boarding-tooltip/on-boarding-tooltip-target-selectors';

interface BottomNavigationBarMenuItemComponentProps extends MenuItemComponentProps, ComponentServicesPick<'bottomNavigationBar'> {
    badge?: React.FC;
}
const ComponentBody: React.FC<BottomNavigationBarMenuItemComponentProps> = observer((props) => {

    const menuItem = props.menuItem;

    const handleLinkClick = async ()  => {
        props.bottomNavigationBar.activeMenuItemKey = props.menuItem.key;
        await props.menuItem.execute();
    }

    let isActive: boolean;

    if (props.bottomNavigationBar.activeMenuItemKey) {
        isActive = props.menuItem.key === props.bottomNavigationBar.activeMenuItemKey;
    } else {
        isActive = props.menuItem.isMatchToCurrentUrl;
    }

    return (
        <BottomNavigationBarMenuItemBox key={menuItem.key}
                                        onClick={handleLinkClick}
                                        isActive={isActive}
                                        type={menuItem.key}
                                        className={classNames(menuItem.key, TOOLTIP_TARGET_BOTTOM_NAV_BAR_INDICATOR)}>
            {props.badge && <props.badge/>}
            <BottomNavigationBarMenuItemIconComponent menuItem={menuItem} isActive={isActive}/>
            <BottomNavigationBarMenuItemTextBox isActive={isActive}>
                {menuItem.text}
            </BottomNavigationBarMenuItemTextBox>
        </BottomNavigationBarMenuItemBox>
    );
});

export const BottomNavigationBarMenuItemComponent = withServices(ComponentBody, ['bottomNavigationBar']);